import React, {FC} from "react";
import {CgSpinner} from "react-icons/cg";
import {AnimatePresence, motion} from "framer-motion";

interface Props {
    small?:boolean;
    error?:string;
}

const Loading: FC<Props> = (props) => {
    let divClasses = props.small ? '' : 'w-full h-screen flex flex-col items-center space-y-4 justify-center'
    let mainClasses = 'flex items-center justify-center'
    let headingClass = props.small ? 'text-md font-semibold mr-2' : 'text-2xl font-bold mr-2'
    let iconClass = props.small ? 'animate-spin text-3xl' : 'animate-spin text-7xl'

    return (
        <motion.div initial={{opacity:0}} exit={{opacity:0}} animate={{opacity:1}} className={divClasses}>
            <div className={mainClasses}>
                <h1 className={headingClass}>SpaceMachine</h1>
                <CgSpinner className={iconClass}/>
            </div>
            <AnimatePresence>
                {props.error && <motion.h3 initial={{opacity:0}} exit={{opacity:0}} animate={{opacity:1}} className='text-error-brighter'>{props.error}</motion.h3>}
            </AnimatePresence>
        </motion.div>
    );
};

export default Loading;